import { defineStore } from 'pinia'
import type { ICenter } from 'src/interfaces/center'
import type { IOrgInfoWithToken } from 'src/interfaces/org'
import type { IProgram } from 'src/interfaces/program'
import type { ISpace } from 'src/interfaces/space'

export interface IResState {
  centers: ICenter[] | []
  spaces: ISpace[] | []
  programs: IProgram[] | []
  orgList: IOrgInfoWithToken[]
}
export const useResStore = defineStore('pinia/res', {
  state: (): IResState => ({
    centers: [],
    spaces: [],
    programs: [],
    orgList: [],
  }),
  getters: {
    noneShapeSpaces: (state) =>
      state.spaces?.filter((space) => !space.shape) ?? [],
  },
  actions: {
    setCenters(centers: ICenter[]) {
      this.centers = centers
    },
    setSpaces(spaces: ISpace[]) {
      this.spaces = spaces
    },
    setSpaceInList(space: ISpace) {
      const index = this.spaces.findIndex((item) => item.id === space.id)
      this.spaces[index] = space
    },
    setSpaceLastIndex(space: ISpace) {
      const i = this.spaces.findIndex((item) => item.id === space.id)
      const s = this.spaces[i]
      this.spaces.splice(i, 1)
      this.spaces = [...this.spaces, s]
    },
    setProgrames(programs: IProgram[]) {
      this.programs = programs
    },
    setOrgList(orgList: IOrgInfoWithToken[]) {
      this.orgList = orgList
    },
  },
})
